'use strict';


export default function run( $cookies, $location, $rootScope, $state, $transitions ) {
  'ngInject';

  $rootScope.showMenu = true;
  $rootScope.isMember = false;
  $rootScope.videoLink = 'trailer';

  if( $cookies.get('sonWarning') === undefined && $location.path() !== '/warning' ) {
    $state.go('warning');
  }
  else if ($cookies.get('xerAuth') !== undefined) {
    $rootScope.isMember = true;
    $rootScope.videoLink = 'video';
  }

  $transitions.onSuccess({}, (trans) => {
    trans.promise.finally( () => {
      $rootScope.pageTitle = trans.$to().data.title;

      // Auto show / hide the menu based on routing params
      if( !trans.$to().data.hasOwnProperty('showMenu') ) {
        $rootScope.showMenu = true;
      }
      else {
        $rootScope.showMenu = trans.$to().data.showMenu;
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src/app/app.run.js